'use strict';

var cachedPromise = null;

/**
 * @param {string} value
 * @returns {string}
 */
function escapeHtml(value) {
	return String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

/**
 * @param {JQuery} $layer
 * @returns {{ url: string, title: string, prefix: string }}
 */
function getConfig($layer) {
	var prefix = $layer.hasClass('search-desktop-layer')
		? 'search-desktop-layer'
		: 'search-mobile-layer';

	return {
		url: $layer.data('mostPopularUrl'),
		title: $layer.data('mostPopularTitle') || 'Most Popular',
		prefix: prefix
	};
}

/**
 * @param {string} url
 * @returns {JQuery.jqXHR}
 */
function fetchCategories(url) {
	if (!url) {
		return $.Deferred().resolve({ available: false, categories: [] }).promise();
	}

	if (!cachedPromise) {
		cachedPromise = $.ajax({
			url: url,
			method: 'GET',
			dataType: 'json'
		}).fail(function () {
			cachedPromise = null;
		});
	}

	return cachedPromise;
}

/**
 * @param {Array<Object>} categories
 * @param {string} title
 * @param {string} prefix
 * @returns {string}
 */
function renderCategories(categories, title, prefix) {
	if (!categories.length) {
		return '';
	}

	var items = categories.map(function (category) {
		return '<li class="item">'
			+ '<a href="' + escapeHtml(category.url) + '" class="' + prefix + '__link">'
			+ escapeHtml(category.name)
			+ '</a></li>';
	}).join('');

	return '<section class="' + prefix + '__most-popular" aria-label="' + escapeHtml(title) + '">'
		+ '<h3 class="' + prefix + '__title">' + escapeHtml(title) + '</h3>'
		+ '<ul class="' + prefix + '__list" role="list">' + items + '</ul>'
		+ '</section>';
}

/**
 * @param {Array<Object>} categories
 * @param {string} title
 * @returns {string}
 */
function renderSearchNoResultsCategories(categories, title) {
	if (!categories.length) {
		return '';
	}

	var items = categories.map(function (category) {
		return '<li class="lvz-search-no-results__popular-item">'
			+ '<a href="' + escapeHtml(category.url) + '" class="lvz-search-no-results__popular-link">'
			+ escapeHtml(category.name)
			+ '</a></li>';
	}).join('');

	return '<section class="lvz-search-no-results__popular" aria-label="' + escapeHtml(title) + '">'
		+ '<h2 class="lvz-search-no-results__section-title">' + escapeHtml(title) + '</h2>'
		+ '<ul class="lvz-search-no-results__popular-list" role="list">' + items + '</ul>'
		+ '</section>';
}

/**
 * Loads Most Popular categories into the editorial slot.
 *
 * @param {JQuery} $layer - `.search-desktop-layer` or `.search-mobile-layer`
 * @param {JQuery} $editorial - editorial container inside the layer
 * @returns {JQuery.Promise}
 */
function loadIntoEditorial($layer, $editorial) {
	if (!$layer.length || !$editorial.length) {
		return $.Deferred().resolve().promise();
	}

	var config = getConfig($layer);

	return fetchCategories(config.url).then(function (response) {
		if (response && response.available && response.categories.length) {
			$editorial
				.html(renderCategories(response.categories, config.title, config.prefix))
				.removeClass('d-none')
				.attr('aria-hidden', 'false');
		} else {
			$editorial.empty().addClass('d-none').attr('aria-hidden', 'true');
		}
	});
}

/**
 * Hides the editorial slot without clearing cached API data.
 *
 * @param {JQuery} $editorial
 */
function hideEditorial($editorial) {
	if (!$editorial.length) {
		return;
	}

	$editorial.addClass('d-none').attr('aria-hidden', 'true');
}

/**
 * Loads Most Popular categories into search empty / no-results message blocks.
 *
 * @param {JQuery} $message - `.lvz-content-search-empty__message`
 * @returns {JQuery.Promise}
 */
function loadIntoSearchEmptyMessage($message) {
	var $mount = $message.find('.lvz-search-no-results__popular-mount').first();

	if (!$message.length || !$mount.length) {
		return $.Deferred().resolve().promise();
	}

	var config = {
		url: $message.data('mostPopularUrl'),
		title: $message.data('mostPopularTitle') || 'Most Popular'
	};

	return fetchCategories(config.url).then(function (response) {
		if (response && response.available && response.categories.length) {
			$mount.html(renderSearchNoResultsCategories(response.categories, config.title));
		} else {
			$mount.empty();
		}
	});
}

module.exports = {
	loadIntoEditorial: loadIntoEditorial,
	hideEditorial: hideEditorial,
	loadIntoSearchEmptyMessage: loadIntoSearchEmptyMessage
};
